import Vue from 'vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import Papa from 'papaparse'

const defaultConfig = {
  delimiter: '',
  newline: '',
  quoteChar: '"',
  escapeChar: '"',
  header: true,
  transformHeader: (header) => header.trim(),
  dynamicTyping: false,
  preview: 0,
  encoding: '',
  worker: false,
  comments: false,
  step: undefined,
  complete: undefined,
  error: undefined,
  download: false,
  downloadRequestHeaders: undefined,
  downloadRequestBody: undefined,
  skipEmptyLines: true,
  chunk: undefined,
  chunkSize: undefined,
  fastMode: undefined,
  beforeFirstChunk: undefined,
  withCredentials: undefined,
  transform: (value) => value.trim(),
  delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP],
  skipFirstNLines: 0
}

const parseCsv = (csvData, config = defaultConfig) => {
  const result = Papa.parse(csvData, config)

  return {
    headers: result.meta.fields,
    rows: result.data
  }
}

Vue.prototype.$parseCsv = parseCsv

export default parseCsv
